import i18next from 'i18next';
import { listNames } from './list-names';
/** "Sign Ethan in too?" for the parent's other children, or "Sign yourself in too?" for a parent who is also staff */
export const kioskFollowUpQuestion = (action, followUp) => {
    if (followUp.kind === 'yourself') {
        return action === 'signIn'
            ? i18next.t($ => $.stat.signinSelectChildren.lib.src.translations.json.followUp.signYourselfInToo)
            : i18next.t($ => $.stat.signinSelectChildren.lib.src.translations.json.followUp.signYourselfOutToo);
    }
    const names = listNames(followUp.childNames);
    return action === 'signIn'
        ? i18next.t($ => $.stat.signinSelectChildren.lib.src.translations.json.followUp.signInToo, { names })
        : i18next.t($ => $.stat.signinSelectChildren.lib.src.translations.json.followUp.signOutToo, { names });
};
